import classes from "../Kiosk_viennaPlzen_redesign.module.css";
import {React, useState} from "react";
import logo from "../../../../store/logo.png"
import {path} from "../../../../routes";

const ExploreRecord = (props) => {

    return <div className={classes.exrecord}>
        <div className={classes.exrecordPic}><img src={path+"/admin/"+props.data.file1}/></div>
        <div className={classes.exrecordTText}>
            <label className={classes.headTextexp}>{props.data.header}</label>
            <label className={classes.headTextprosty} style={{ whiteSpace: "pre-line" }}>{props.data.content}</label>
        </div>
        <div className={classes.qrgrid}><img src={path+"/admin/"+props.data.file2}/></div>
    </div>
}
export default ExploreRecord